import SinglePromoteurCard from "./SinglePromoteurCard";
import { useSelector } from "react-redux";

const PromoteursBody = ({ listePromoteurs }) => {
  const { user } = useSelector((state) => state.userAuthReducer);

  return (
    <section className="grid-catalogue gap10 mt-10">
      {listePromoteurs?.data?.map((promoteur) => {
        const totalLots = promoteur.programmes_inclu.reduce(
          (sum, programme) => sum + (programme.lots?.length || 0),
          0
        );

        return (
          <SinglePromoteurCard
            user={user}
            key={promoteur.id}
            imgUrl={
              promoteur.logo?.url
                ? `${process.env.REACT_APP_IMAGE_END_POINT}${promoteur.logo?.url}`
                : "./assets/imgNotFound.webp"
            }
            title={promoteur.name}
            nbrProgrammes={promoteur.programmes_inclu.length}
            nbrLots={totalLots}
            lastSync={promoteur.lastSync}
            original_id={promoteur.original_id}
          />
        );
      })}
    </section>
  );
};

export default PromoteursBody;
